export default "__VITE_ASSET__Bi_Wl$f1__"